var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.85 198.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e12c42;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98,2.33A53.33,53.33,0,0,0,44.68,55.66V79.91H30.14A14.62,14.62,0,0,0,15.59,94.45v92.13a14.62,14.62,0,0,0,14.55,14.54H165.9a14.63,14.63,0,0,0,14.55-14.54V94.45A14.63,14.63,0,0,0,165.9,79.91H151.35V55.66A53.32,53.32,0,0,0,98,2.33ZM98,12a43.44,43.44,0,0,1,43.64,43.63V79.91H54.38V55.66A43.44,43.44,0,0,1,98,12ZM30.14,89.6H165.9a4.74,4.74,0,0,1,4.85,4.85v92.13a4.74,4.74,0,0,1-4.85,4.85H30.14a4.74,4.74,0,0,1-4.85-4.85V94.45a4.74,4.74,0,0,1,4.85-4.85ZM98,109a19.47,19.47,0,0,0-19.4,19.39,19,19,0,0,0,4.85,12.28v16.82a14.55,14.55,0,0,0,29.1,0V140.67a18.93,18.93,0,0,0,4.84-12.28A19.47,19.47,0,0,0,98,109Zm0,9.7a9.66,9.66,0,0,1,6.44,16.89,4.93,4.93,0,0,0-1.59,3.64v18.26a4.85,4.85,0,0,1-9.7,0V139.23a4.89,4.89,0,0,0-1.59-3.64A9.66,9.66,0,0,1,98,118.7Z",
    transform: "translate(-15.59 -2.33)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.32242506.svg";
export { ForwardRef as ReactComponent };